import { render, staticRenderFns } from "./StageChooseShop.vue?vue&type=template&id=e4cdbe20"
import script from "./StageChooseShop.vue?vue&type=script&lang=ts"
export * from "./StageChooseShop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4cdbe20')) {
      api.createRecord('e4cdbe20', component.options)
    } else {
      api.reload('e4cdbe20', component.options)
    }
    module.hot.accept("./StageChooseShop.vue?vue&type=template&id=e4cdbe20", function () {
      api.rerender('e4cdbe20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/StageChooseShop.vue"
export default component.exports